<div class="attribute-list attribute-list-container te-scrollable-container tw-h-full sm:!tw-h-fit tw-pb-64 sm:!tw-pb-0" [ngClass]="{ 'attribute-list-hide': componentsFactory.selected }" [shown]="componentsFactory.showAttributeList">
  <template-attribute-list></template-attribute-list>
</div>

<div class="attribute-component" [shown]="!componentsFactory.showAttributeList">
  <template-component></template-component>
</div>
